export const BACKEND_URI =
  (window as any)?.env?.VITE_API_ENDPOINT || import.meta.env.VITE_API_ENDPOINT;
